import _createForOfIteratorHelper from "/var/www/commonsku/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
/**
 * Counts number of samples when the thread was not idle (stackId is defined)
 * @param samples Array of collected samples
 * @returns Number of samples
 */
export function getNumberOfSamples(samples) {
  var numberOfSamples = 0;
  var _iterator = _createForOfIteratorHelper(samples),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var sample = _step.value;
      if (sample.stackId !== undefined) {
        numberOfSamples++;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return numberOfSamples;
}